import {
	Component,
	OnInit,
	OnDestroy,
	AfterViewInit,
	NgModule,
	HostListener,
	ViewChild,
	ViewChildren,
	ChangeDetectorRef,
	QueryList,
	ElementRef,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Inject } from '@angular/core';
import { DOCUMENT, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';

// ** rxjs
import { finalize, switchMap, tap, filter } from 'rxjs/operators';
import { of, Observable, pipe, forkJoin } from 'rxjs';

// ** service
import { MessageService } from '@app/core/services';
import { LayoutService } from '@app/core/services/layout.service';
import { NewsService } from '@app/core/services/news.service';
import { HomeService } from '@app/core/services';

// ** com
import { SwiperComponent } from 'swiper/angular';

// * primeng
import { Accordion } from 'primeng/accordion';

// ** 第三方
import SwiperCore, { EffectFade, Navigation, Thumbs, Scrollbar, Autoplay, Pagination } from 'swiper';
SwiperCore.use([EffectFade, Navigation, Thumbs, Scrollbar, Autoplay, Pagination]);

// ** others

@Component({
	selector: 'app-index',
	templateUrl: 'index.component.html',
	styleUrls: ['./index.component.scss'],
	providers: [MessageService],
})
export class IndexComponent implements OnInit, OnDestroy, AfterViewInit {
	@ViewChildren(Accordion) accordions: QueryList<Accordion>;
	@ViewChild('heroSwiper', { static: false }) heroSwiper: SwiperComponent;
	@ViewChild('securitySwiper', { static: true }) securitySwiper: SwiperComponent;
	// @ViewChild('solutionSwiper', { static: true }) solutionSwiper: SwiperComponent;
	@ViewChild('collabSwiper', { static: true }) collabSwiper: SwiperComponent;
	@ViewChildren('pyramidPic') pyramidPics: QueryList<ElementRef>;
	@ViewChildren('flip') flips: QueryList<ElementRef>;

	pagination = 3;
	pagination1 = 1;
	thumbsSwiperBanner: any;
	thumbsSwiperRelation: any;

	/** swiper 是否顯示 */
	showSwiper = false;
	isBrowser = false;

	/** swiper current 頁數 reference */
	carouselPageRef = 1;

	/** slide 數 */
	slidesPerView = 1;

	/** 服務統計 fliper */
	fliper = [
		{ Type: 'organization', Count: 34, Title: '安全科技的三大願景' },
		{ Type: 'project', Count: 57, Title: '安全科技的三大願景' },
		{ Type: 'solution', Count: 183, Title: '安全科技的三大願景' },
	];

	/** 服務統計 標題 */
	securityTitle = this.fliper[0].Title;
	/** 服務統計 中文序號 map */
	serviceMap = { organization: 0, project: 1, solution: 2 };
	/** 服務統計 三張卡片是否是進到畫面的 observer */
	observer;

	/** 三安 tab index */
	tabIdx;

	/** 輪播新聞 */
	highlightNews;

	/** 合作對象 idx */
	accPoliticalIndex = -1;
	accEnterpriseIndex = -1;

	governmentFront = [];
	governmentBack = [];
	enterpriseFront = [];
	enterpriseBack = [];

	@HostListener('window:resize', ['$event'])
	onResize(event: Event): void {
		if (this.isBrowser) this.onWindowResize();
	}

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId,
		private cdr: ChangeDetectorRef,
		private newsService: NewsService,
		private homeService: HomeService,
		private layoutService: LayoutService,
		public router: Router,
	) {
		this.isBrowser = isPlatformBrowser(this.platformId);
		if (this.isBrowser) this.onWindowResize();
	}

	ngOnInit() {
		const canonical = this.document.querySelector('link[rel="canonical"]') as HTMLAnchorElement | null;
		if (canonical) canonical.href = 'https://bigaunt666.github.io/bigaunt/';
		this.getHighlightNews();
	}

	ngAfterViewInit() {}

	// - 依據 window size 調整 swiper 顯示 slide 數量
	onWindowResize() {
		// const lg = window.innerWidth > 1200;
		// const md = window.innerWidth > 440 && window.innerWidth < 1200;
		const sm = window.innerWidth <= 440;
		if (sm) this.updateSlidePerPage(1.4);
		else this.updateSlidePerPage(1);
		this.updateScroll();
	}

	// - manual update swiper scrollbar for ng lifecycle hotfix
	updateScroll() {
		setTimeout(() => {
			this.heroSwiper?.swiperRef?.scrollbar.updateSize();
			this.heroSwiper?.swiperRef?.scrollbar.setTranslate();
		});
	}

	// - 更新品牌優勢幻燈片
	updatePageIdx() {
		this.carouselPageRef = this.heroSwiper.swiperRef.activeIndex + 1;
		this.cdr.detectChanges();
	}

	// - 深入瞭解
	goViewNews(prefix, fileTitle) {
		return `newsCenter/${prefix}/${fileTitle}`;
	}

	// - 取得輪播新聞
	getHighlightNews() {
		of(this.layoutService.setPageLoading(true))
			.pipe(
				switchMap(() => forkJoin([this.getNews$(), this.getElectronicNews$()])),
				tap(([news, eNews]) => (this.highlightNews = [...news, ...eNews].filter(x => x.Highlight))),
				// tap(() => {
				// 	this.highlightNews.sort((a, b) => {
				// 		const dateA = new Date(a.Date);
				// 		const dateB = new Date(b.Date);
				// 		return dateB.getTime() - dateA.getTime();
				// 	});
				// 	this.highlightNews = this.highlightNews.slice(0, 5);
				// }),
				tap(() => this.initSwiper()),
				finalize(() => this.layoutService.setPageLoading(false)),
			)
			.subscribe();
	}

	// - 初始化 swiper
	initSwiper() {
		setTimeout(() => (this.showSwiper = true));
		setTimeout(() => {
			this.heroSwiper?.swiperRef?.on('slideChange', e => this.updatePageIdx());
			this.securitySwiper?.swiperRef?.on('slideChange', e => this.onSecuritySwiperChange(e));
		});
	}

	updateSlidePerPage(val: number) {
		this.slidesPerView = val;
	}

	onTabChange(e) {
		const { index } = e;
		this.tabIdx = index;
		const picSrcArr = [
			'/assets/images/indexPage/pyramid-1024-nation.webp',
			'/assets/images/indexPage/pyramid-1024-info.webp',
			'/assets/images/indexPage/pyramid-1024-order.webp',
		];

		this.pyramidPics.first.nativeElement.src = picSrcArr[index];
		this.securityTitle = this.fliper[index].Title;
		this.securitySwiper.swiperRef.slideTo(index);
	}

	onSecuritySwiperChange(e) {
		this.onTabChange({ index: e.activeIndex });
	}

	ngOnDestroy() {
		const body = this.document.getElementsByTagName('body')[0];
		body?.classList.remove('index-page');
	}

	/* -------------------------------------------------------------------------- */
	/*                                     api                                    */
	/* -------------------------------------------------------------------------- */

	getNews$(): Observable<any> {
		return this.newsService.getNews().pipe();
	}

	getElectronicNews$(): Observable<any> {
		return this.newsService.getElectronicNews().pipe();
	}
}
